import React from "react";
import { useAlert } from "react-alert";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import { ClipboardButtonContainer, ClipboardWrapper, DivWrapper, EmailContainer, FallbackContainer, ImageContainer } from "./contact-form.styles";

import emailImg from '../../assets/contact/email.png';
import copyImg from '../../assets/contact/copy.png';
import useMediaQuery from "../media-query/media-query.component";


const ContactForm = () => {

  const alert = useAlert();

  const address = 'kontakt@bogensport-dortmund.de';

  const openEmail = () => {
    alert.info("E-Mail-Programm wird geöffnet.");
    window.location.assign('mailto:'+address);
  }
  const isMobile = useMediaQuery('(max-width: 800px)');
    if(!isMobile) {
      return (
        <DivWrapper>
          <h1>Kontakt</h1>
          <FallbackContainer>
              <h2>Wenn Du dich bei uns bewerben willst oder noch Fragen offen sind, schreibe einfach eine kurze E-Mail an:<br /><br />
                <EmailContainer id="email">
                  <span>kontakt@bogensport-dortmund.de</span>
                  <ClipboardWrapper>
                    <CopyToClipboard text={address} onCopy={() => alert.success("E-Mail-Adresse kopiert.")}>
                      <ClipboardButtonContainer data-tip="E-Mail-Adresse kopieren">
                        <ReactTooltip />
                        <ImageContainer src={copyImg} alt="copyImg"/>
                      </ClipboardButtonContainer>
                    </CopyToClipboard>
                    <ClipboardButtonContainer  data-tip="E-Mail schreiben"
                      onClick={() => openEmail() }>
                      <ReactTooltip />
                      <ImageContainer src={emailImg} alt="emailImg" />
                    </ClipboardButtonContainer>
                  </ClipboardWrapper>
                </EmailContainer>
              </h2>
            </FallbackContainer>
        </DivWrapper>
      );
    } else {
      return (
        <DivWrapper>
          <h1>Kontakt</h1>
          <FallbackContainer>
              <h3>Wenn Du dich bei uns bewerben willst oder noch Fragen offen sind, schreibe einfach eine E-Mail an:<br /><br />
                <span>kontakt@bogensport-dortmund.de</span>
                <EmailContainer id="email">
                  <CopyToClipboard text={address} onCopy={() => alert.success("E-Mail-Adresse kopiert.")}>
                    <ClipboardButtonContainer data-tip="E-Mail-Adresse kopieren">
                      <text textAnchor="middle" x="50%" dominantBaseline="hanging" textLength="50" lengthAdjust="spacing">E-Mail</text>
                      <ImageContainer src={copyImg} alt="copyImg"/>
                      <text textAnchor="middle" x="50%" y="90%" dominantBaseline="text-after-edge" textLength="60" lengthAdjust="spacing">kopieren</text>
                    </ClipboardButtonContainer>
                  </CopyToClipboard>
                  <ClipboardButtonContainer data-tip="E-Mail schreiben"
                    onClick={() => openEmail() }>
                    <text textAnchor="middle" x="50%" dominantBaseline="hanging" textLength="50" lengthAdjust="spacing">E-Mail</text>
                    <ImageContainer src={emailImg} alt="emailImg" />
                    <text textAnchor="middle" x="50%" y="90%" dominantBaseline="text-after-edge" textLength="60" lengthAdjust="spacing">verfassen</text>
                  </ClipboardButtonContainer>
                </EmailContainer>
              </h3>
            </FallbackContainer>
        </DivWrapper>
      );
    }
};

export default ContactForm;